var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1274_3383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.06055 10.9236H8.38277",
    stroke: "#61646F",
    strokeWidth: 0.870833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.62002 8.14483C1.41507 6.81112 1.3126 6.14431 1.56474 5.55316C1.81687 4.962 2.37627 4.55753 3.49507 3.7486L4.33098 3.14421C5.72275 2.13792 6.4186 1.63477 7.22157 1.63477C8.02454 1.63477 8.72039 2.13792 10.1122 3.14421L10.9481 3.7486C12.0669 4.55753 12.6263 4.962 12.8784 5.55316C13.1305 6.14431 13.0281 6.81112 12.8231 8.14483L12.6484 9.28208C12.3578 11.1727 12.2125 12.118 11.5345 12.6819C10.8565 13.2459 9.86525 13.2459 7.88271 13.2459H6.56043C4.57791 13.2459 3.58666 13.2459 2.90862 12.6819C2.23059 12.118 2.08532 11.1727 1.79479 9.28208L1.62002 8.14483Z",
    stroke: "#61646F",
    strokeWidth: 0.870833,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1274_3383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9333,
    height: 13.9333,
    fill: "white",
    transform: "translate(0.255859 0.473633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7658e073cb67370a0097f1280cae50ba.svg";
export { ForwardRef as ReactComponent };